import { render, staticRenderFns } from "./BoxContent7.vue?vue&type=template&id=bd1e7b3e&scoped=true"
import script from "./BoxContent7.vue?vue&type=script&lang=js"
export * from "./BoxContent7.vue?vue&type=script&lang=js"
import style0 from "./BoxContent7.vue?vue&type=style&index=0&id=bd1e7b3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1e7b3e",
  null
  
)

export default component.exports